module.exports = __webpack_public_path__ + "static/media/Organization.20412be2.png";